import { Injectable, inject, signal, computed } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter, switchMap } from 'rxjs/operators'
import { PetRepositoryApi, NotificationStats } from '../../data/api/pet-repository.api'

@Injectable({ providedIn: 'root' })
export class NotificationsService {

  readonly #petApi = inject(PetRepositoryApi)
  readonly #router = inject(Router)

  readonly #petId = signal<number | null>(null)

  readonly #countPetNotifications = signal(0)
  readonly #countTeamNotifications = signal(0)
  readonly #countMessages = signal(0)

  readonly countPetNotifications = this.#countPetNotifications.asReadonly()
  readonly countTeamNotifications = this.#countTeamNotifications.asReadonly()
  readonly countMessages = this.#countMessages.asReadonly()
  readonly countNotifications = computed(() => this.#countPetNotifications() + this.#countTeamNotifications())

  constructor() {
    this.#router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      filter(() => this.#petId() !== null),
      switchMap(() => this.#petApi.fetchStatsNotifications(this.#petId()!))
    ).subscribe(stats => this.#applyStats(stats))
  }

  updateGlobalCountNotification(petId: number) {
    this.#petId.set(petId)
    this.#petApi.fetchStatsNotifications(petId)
      .subscribe(stats => this.#applyStats(stats))
  }

  setPetNotificationsToZero() {
    this.#countPetNotifications.set(0)
    this.#countTeamNotifications.set(0)
  }

  #applyStats(stats: NotificationStats) {
    const petNotifs = stats.pet.comments + stats.pet.follow + stats.pet.likes
      + stats.pet.members + stats.pet.mentions
    this.#countPetNotifications.set(petNotifs)
    this.#countTeamNotifications.set(stats.teams)
    this.#countMessages.set(stats.pet.messages)
  }
}
